export const nameToUrlParam = (name: string) => {
  return name.replace(/\s|\//gm, ' ').split(' ').join('-').toLowerCase();
};
